export const BreakPoints = {
  xs: 600,
  sm: 960,
  md: 1280
};
